import { Component, Input } from '@angular/core';
import { Link } from '../../../../shared/interfaces/link';

/// A footer link, with its label's key (Multilang_Culture_Spec.md 5.2): shown through the t pipe, the label being its English.
export type FooterLink = Link & { key?: string };

@Component({
    selector: 'app-footer-links',
    templateUrl: './links.component.html',
    styleUrls: ['./links.component.scss']
})
export class LinksComponent {
    @Input() header: string;
    @Input() links: FooterLink[] = [];

    constructor() { }
}
